import MainContainer from "./MainContainer";
import SecondaryContainer from "./SecondaryContainer";
import Footer from "./Footer";
import { useSelector } from "react-redux";
import DNSError from "./DNSError";
const Browse = () => {
  const movies = useSelector((store) => store.movies?.nowPlayingMovies);
  if (!movies) return <DNSError />;
  return (
    <div className="font-poppins ">
      <MainContainer />
      <SecondaryContainer />
      <Footer />
    </div>
  );
};

export default Browse;
